import { render, staticRenderFns } from "./LinhaAssistenteRedirect.vue?vue&type=template&id=71ab9690&"
import script from "./LinhaAssistenteRedirect.vue?vue&type=script&lang=js&"
export * from "./LinhaAssistenteRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports